import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import cmplogo from "assets/img/cmp-logo.svg";

import lockScreenPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import { Auth } from "aws-amplify";
import Amplify from "aws-amplify";
import aws_exports from "../../aws-exports";

Amplify.configure(aws_exports);

class LockScreenPage extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: "cardHidden",
      email: "",
      tempCode: "",
      tempCodeState: "",
      emailState: "",
      tr: false,
      color: "success",
      message: ""
    };
  }

  verifyLength(value, length) {
    if (value.length >= length) {
      return true;
    }
    return false;
  }

  verifyEmail(value) {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }

  handleChange(event, type) {
    this.setState({
      [event.target.id]: event.target.value
    });

    switch (type) {
      case "tempCode":
        if (this.verifyLength(event.target.value, 4)) {
          this.setState({ tempCodeState: "success" });
        } else {
          this.setState({ tempCodeState: "error" });
        }
        break;
      case "email":
        if (this.verifyEmail(event.target.value)) {
          this.setState({ emailState: "success" });
        } else {
          this.setState({ emailState: "error" });
        }
        break;
      default:
      // do nothing
    }
  }

  confirmClick() {
    if (this.state.tempCode === "") {
      this.setState({ tempCodeState: "error" });
    }
    if (this.state.email === "") {
      this.setState({ emailState: "error" });
    }
  }

  showNotification(place) {
    if (!this.state[place]) {
      var x = [];
      x[place] = true;
      this.setState(x);
      setTimeout(
        function() {
          x[place] = false;
          this.setState(x);
        }.bind(this),
        10000
      );
    }
  }

  handleSubmit = async event => {
    event.preventDefault();
    this.confirmClick();
    if (this.state.tempCode !== "" && this.state.email !== "") {
      try {
        let email = this.state.email;
        let tempCode = this.state.tempCode;
        Auth.confirmSignUp(email, tempCode, {
          // Optional. Force user confirmation irrespective of existing alias. By default set to True.
          forceAliasCreation: true
        })
          .then(data => {
            if (data === "SUCCESS") {
              this.setState({ color: "success" });
              this.setState({ message: "Account Confirmed. Please Log In " });
              this.showNotification("tr");
              setTimeout(
                function() {
                  this.props.history.push("/login");
                }.bind(this),
                6000
              );
            } else {
              this.setState({ color: "warning" });
              this.setState({ message: "Cannot Confirm the Account" });
              this.showNotification("tr");
            }
          })
          .catch(err => {
            this.setState({ color: "warning" });
            this.setState({ message: err["message"] });
            this.showNotification("tr");
          });
      } catch (e) {
        this.setState({ color: "warning" });
        this.setState({ message: e["message"] });
        this.showNotification("tr");
      }
    }
  };

  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function() {
        this.setState({ cardAnimaton: "" });
      }.bind(this),
      700
    );
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.fullPage}>
        <div className={classes.container}>
          <GridItem xs={12} sm={12} md={3}>
            <Snackbar
              place="tr"
              color={this.state.color}
              message={this.state.message}
              open={this.state.tr}
              closeNotification={() => this.setState({ tr: false })}
              close
            />
          </GridItem>
          <GridContainer justify="center">
            <GridItem xs={12} sm={6} md={4}>
              <form onSubmit={this.handleSubmit}>
                <Card login className={classes[this.state.cardAnimaton]}>
                  <CardHeader
                    className={`${classes.cardHeader} ${classes.textCenter}`}
                    color="primary"
                  >
                    <img src={cmplogo} alt="..." />
                    <h4 className={classes.cardTitle}>
                      Welcome to Customer Management Platform
                    </h4>
                  </CardHeader>
                  <CardBody>
                    <h4 className={classes.cardTitle}>
                      Please confirm your Registration
                    </h4>

                    <CustomInput
                      success={this.state.emailState === "success"}
                      error={this.state.emailState === "error"}
                      labelText="Email *"
                      id="email"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        onChange: event => this.handleChange(event, "email"),
                        type: "email",
                        endAdornment: (
                          <InputAdornment position="end">
                            <Icon className={classes.inputAdornmentIcon}>
                              email
                            </Icon>
                          </InputAdornment>
                        )
                      }}
                    />

                    <CustomInput
                      success={this.state.tempCodeState === "success"}
                      error={this.state.tempCodeState === "error"}
                      labelText="Confirmation Code *"
                      id="tempCode"
                      formControlProps={{
                        fullWidth: true
                      }}
                      inputProps={{
                        onChange: event => this.handleChange(event, "tempCode"),
                        type: "text",
                        endAdornment: (
                          <InputAdornment position="end">
                            <Icon className={classes.inputAdornmentIcon}>
                              lock_outline
                            </Icon>
                          </InputAdornment>
                        )
                      }}
                    />
                  </CardBody>
                  <CardFooter className={classes.justifyContentCenter}>
                    <Button color="secondary" type="submit">
                      Confirm
                    </Button>
                  </CardFooter>
                </Card>
              </form>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

LockScreenPage.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(lockScreenPageStyle)(LockScreenPage);



// WEBPACK FOOTER //
// ./src/views/Pages/LockScreenPage.jsx